<template>
  <div v-if="branch" class="flex justify-between w-full branches-wrapper">
    <div>
      <p class="item-title">{{ branch.Nombre }}</p>
      <p class="item-subtitle">{{ branch.Provincia }}</p>
    </div>
    <div class="flex items-center">
      <label class="switch">
        <input
          type="checkbox"
          :checked="branch.IdSucursal.toString() === user.branch_id"
          @change="toggleBranch($event, branch.IdSucursal.toString())"
        />
        <span class="slider round"></span>
      </label>
      <feather-icon
        @click="goBranchesSettings"
        icon="ChevronRightIcon"
        svgClasses="h-6 w-6 mx-2 cursor-pointer"
      />
    </div>
  </div>
</template>

<script>
import { userUpdate } from "../../services/users.service";
import { setLocalStorage } from "../../utils/utils";
export default {
  name: "Branch",
  props: {
    branch: Object,
    user: Object,
  },
  methods: {
    goBranchesSettings() {
      this.$router.push({
        path: `/flete-dinamico/sucursales-configuracion`,
        query: { branchId: this.branch.IdSucursal },
      });
    },
    toggleBranch(event, id) {
      this.$nextTick(async () => {
        const { data } = await userUpdate({
          idcliente: this.user.cdsur_idcliente,
          branch_id: id,
        });
        setLocalStorage("user", data.user);
        this.$emit("checkboxSelected");
      });
    },
  },
};
</script>
